import { axiom } from '../../lib/axiom';
import React from 'react';
import { ChatPanel } from './ChatPanel';

interface BotChatProps {
  context: 'stream' | 'global';
  streamId?: string;
  streamName?: string;
  onClose: () => void;
}

/**
 * Stream-level floating chat component.
 * Thin wrapper around ChatPanel with stream scope.
 */
export function BotChat({
  context,
  streamId,
  streamName,
  onClose,
}: BotChatProps) {
  // BotChat requires a streamId for chat functionality
  if (!streamId) {
    axiom.warn('BotChat requires a streamId for chat functionality');
    return null;
  }

  return (
    <ChatPanel
      scope="stream"
      variant="floating"
      streamId={streamId}
      streamName={streamName}
      context={context}
      onClose={onClose}
    />
  );
}
